import * as utils from "common/utils";

export default function ProjectedFodderCropRotationsResults({ fodderCropRotationsResults }) {
    if (!fodderCropRotationsResults || fodderCropRotationsResults.length === 0)
        return null;

    return (
        <>
            <div className="HeroPanel u-mt-md u-page-break u-print-border">
                <div className="HeroPanel-title">Fodder crop rotations</div>
                <div className="Table">
                    <table>
                        <thead>
                            <tr>
                                <th>Block name</th>
                                <th className="numeric">N loss - {fodderCropRotationsResults[0].nitrogen?.totalLoss?.unit?.notation}</th>
                                <th className="numeric">N loss - {fodderCropRotationsResults[0].nitrogen?.lossPerHectare?.unit?.notation}</th>
                                <th className="numeric">P loss - {fodderCropRotationsResults[0].phosphorus?.totalLoss?.unit?.notation}</th>
                                <th className="numeric">P loss - {fodderCropRotationsResults[0].phosphorus?.lossPerHectare?.unit?.notation}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fodderCropRotationsResults?.map((block) => {
                                return (
                                    <tr key={block.id}>
                                        <td>{block.name}</td>
                                        <td className="numeric">{utils.numeric.format(block.nitrogen?.totalLoss?.value)}</td>
                                        <td className="numeric">{utils.numeric.format(block.nitrogen?.lossPerHectare?.value, 1)}</td>
                                        <td className="numeric">{utils.numeric.format(block.phosphorus?.totalLoss?.value, 1)}</td>
                                        <td className="numeric">{utils.numeric.format(block.phosphorus?.lossPerHectare?.value, 1)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
